// extracted by mini-css-extract-plugin
module.exports = {"l1aw4b38":"l1aw4b38","l1xsg8m3":"l1xsg8m3"};